import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { WindowHelpers } from "../../more/Helpers";
import { EmploymentPropositionTypes } from "./OE_Types";
import EmploymentPropositionForm from './EmploymentPropositionForm';

class OE_MusicianPropositionAgenda extends compose(AgendaViewBase<any>, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...

 

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
    //    if (this.hasFeature("EvBooking/RoomBlocking")) {
    //        if (this.hasUserRole(["EvBooking_Create"/*, explizit mal nur Create "EvBooking_Edit"*/])) {
    //            this.createContextButton({
    //                label: this.translations["BookingEditor__RoomBlocking"],
    //                callback: lang.hitch(this, this._onClick_CreateRoomBlockingBtn),
    //                placement: "top",
    //                iconClass: "fas fa-calendar-times",
    //                permanent: false
    //            });

    //            this.createContextButton({
    //                label: this.translations["BookingEditor__RoomBlocking"],
    //                callback: lang.hitch(this, this._onClick_CreateRoomBlockingBtn),
    //                placement: "bottombar",
    //                iconClass: "fas fa-calendar-times",
    //                permanent: false
    //            });
    //        }
    //    }
    }

   

    private _onClick_Row(row: StaticTable.StaticTableRow<EmploymentPropositionTypes.EvProjectWithProposition>, rowGroup: StaticTable.StaticTableRowGroup<EmploymentPropositionTypes.EvProjectWithProposition>) {

        let entity = rowGroup.entity;

        this.openForm(entity);

    }

    openForm(entity: EmploymentPropositionTypes.EvProjectWithProposition) {
        if (!entity) return;

        let view = new GenericEntityView();
        view.setContextName("orchestraEmploymentProposition");
        view.setup(entity.ID, entity.Classname, entity.ev_project_name, "ev_project_name", "dlg", null, "orchestraEmploymentProposition", this.getTabContainerName());

        // TODO: statt der View dlg mit Propositionform öffnen

        let form = new EmploymentPropositionForm();
        form.setup(entity.engagement.ID, entity.ID);

        // Propositionform enthält bereits View mit Projekt etc
    }
   
    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        this.setupAgendaViewWithCallfunction(
            "Webtool_API_OrchestraEmploymentProposition__GetMusicianAgendaConfig",
            "Webtool_API_OrchestraEmploymentProposition__GetMusicianProjectList",
            lang.hitch(this, this._onClick_Row),
            null, // Standard-Formatter
            null
        );

        WindowHelpers.setTitles("OrchestraEmploymentProposition_Label__Proposition");        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(OE_MusicianPropositionAgenda);